
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21.6 10.7H5.5L11 5.2c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0l-7.7 7.7c-.5.5-.5 1.3 0 1.8l7.7 7.7c.2.2.6.4.9.4s.7-.1.9-.4c.5-.5.5-1.3 0-1.8l-5.5-5.5h16.1c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3z"}})])
      }
    
      }
    